import * as React from 'react';

interface IIconArrow extends React.DetailedHTMLProps<React.SVGAttributes<SVGElement>, SVGElement> {
    type?: 'up' | 'down' | 'left' | 'right';
}

export const IconArrow = (props: IIconArrow) => {
  const { type } = props;

  let rotate;
  switch (type) {
    case 'up': rotate = 45; break;
    case 'left': rotate = -45; break;
    case 'right': rotate = 135; break;
    case 'down':
    default: rotate = -135; break;
  }

  return (
    // tslint:disable:max-line-length
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <defs>
        <path id="arrow" d="M0 0h16v16H0z"/>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="arrowMask" fill="#fff">
          <use xlinkHref="#arrow"/>
        </mask>
        <path fillRule="nonzero" stroke="#2B87DB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.45 11V4h7" mask="url(#arrowMask)" transform={`rotate(${rotate} 7.95 7.5)`}/>
      </g>
    </svg>
    // tslint:enable:max-line-length
  );
};
